export const HTTP_ENDPOINTS = {
  // Machines
  MACHINES_BASEPATH: 'machines',
  SEND_ACTION: 'actions',

  // Tenants
  TENANTS_BASE_PATH: 'tenants',
  UPDATE_CLIENT_DOMAIN: 'client-domain',
  TENANT_LOGO: 'logo',
  TENANT_AUTHORIZATION: 'authorization',
  TENANT_VALIDATION: 'tenant-validation',

  // Users
  USERS_BASE_PATH: 'tenant-user',

  // Configuration Files
  CONFIGURATION_FILE_BASE_PATH: 'configuration-details',
  CONFIGURATION_FILE_DETAILS: 'details',

  // Tenant Oaibox
  DELETE_MACHINE: 'tenant-machine',
  TENANT_MACHINE_BASE_PATH: 'tenant-machine',
  UNLINK_MACHINE: 'unlink',
  UPDATE_SERIAL_NUMBER: 'serial-number',

  // Machine Configuration
  CREATE_OR_UPDATE_DEFAULT_CONFIGURATION: 'tenant-configurations/ran/default',
  FETCH_DEFAULT_CONFIGURATION: 'tenant-configurations/ran/default',
  CREATE_OR_UPDATE_CUSTOM_CONFIGURATION: 'tenant-configurations/ran/custom',
  GET_CUSTOM_CONFIGURATION: 'tenant-configurations/ran/custom',
  DELETE_CUSTOM_CONFIGURATION: 'tenant-configurations/ran/custom',

  // Builds
  BUILD_BASE_PATH: 'builds',
  BUILD_DETAILS: 'details',
  BUILD_EXECUTABLE: 'executable',
  AVAILABLE_BUILD_COMMIT: 'available-commit',

  // Machines
  FETCH_LATEST_TELEMETRY: 'machines/telemetry',
  MACHINES_PATH: 'machines',
  READY_TO_ASSIGN_MACHINE: 'ready-to-assign',
  ASSIGNED_MACHINE: 'assigned',
  QUALITY_CHECKED_MACHINE: 'quality-checked',
  SHIPPED_MACHINE: 'shipped',
  QUALITY_RULES: 'quality-rules',
  ACTIONS_PATH: 'actions',

  // Stock
  CREATE_ITEM: 'stock',
  FETCH_ALL_ITEMS: 'stock',
  FETCH_ITEM: 'stock',
  UPDATE_ITEM: 'stock',
  ADD_QUANTITY: 'stock',
  FETCH_ALL_ITEM_TYPES: 'stock/types',
  CREATE_ITEM_TYPE: 'stock/types',
  FETCH_BILL_OF_MATERIALS_MACHINE: 'bill-of-materials',
  UPDATE_BILL_OF_MATERIALS_MACHINE: 'bill-of-materials',
  FETCH_TENANT_MACHINE: 'tenants',

  // FORGE
  FORGE_PATH: 'forge',

  // Orders
  ORDERS_PATH: 'orders',
}
